var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("click-and-drag-block " + (!_vm.show ? 'hidden' : '')),on:{"click":_vm.clickHandler}},[_c('div',{staticClass:"click-and-drag"})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/js/components/motor-show/ClickAndDrag.vue?vue&type=template&id=7c414cb4&scoped=true&
// module id = null
// module chunks = 